export default __webpack_public_path__ + "static/media/vision-section-08.c42a6c0c.png";